<div class="patient-analysis">
  <div class="section-header">
    <h2 class="section-title">Analisi Complessive</h2>
    <button
      mat-icon-button
      (click)="toggleInfoPanel()"
      aria-label="Info"
      class="info-button"
    >
      <mat-icon matTooltip="Informazioni sulla panoramica paziente"
        >info</mat-icon
      >
    </button>
  </div>
  @if (isLoading) {
    <div class="loading-container">
      <app-loader [size]="'big'"></app-loader>
    </div>
  }
  @if (!isLoading) {
    <div class="patient-overview-container">
      <div class="table-container">
        <table
          mat-table
          [dataSource]="[patient]"
          class="patient-overview-table"
        >
          <ng-container matColumnDef="totalAppointments">
            <th mat-header-cell *matHeaderCellDef>Appuntamenti Totali</th>
            <td mat-cell *matCellDef="let patient">
              {{ numberOfPastAppointments }}
            </td>
          </ng-container>
          <ng-container matColumnDef="totalAnalyses">
            <th mat-header-cell *matHeaderCellDef>Analisi Totali</th>
            <td mat-cell *matCellDef="let patient">
              {{ numberOfCompletedAnalyses }}
            </td>
          </ng-container>
          <!--- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Azioni</th>
            <td mat-cell *matCellDef="let patient">
              @switch (patientOverviewPipelineState) {
                @case ("READY_TO_START") {
                  <button
                    mat-icon-button
                    (click)="startPatientSummaryPipeline()"
                    matTooltip="Avvia analisi AI"
                    class="action-button"
                  >
                    <mat-icon>play_circle_filled</mat-icon>
                  </button>
                }
                @case ("EXECUTED_NOT_UP_TO_DATE") {
                  <button
                    mat-icon-button
                    (click)="startPatientSummaryPipeline()"
                    matTooltip="Aggiorna analisi AI"
                    class="action-button"
                  >
                    <mat-icon>update</mat-icon>
                  </button>
                }
                @case ("IN_PROGRESS") {
                  <button
                    mat-icon-button
                    (click)="stopPatientSummaryPipeline()"
                    matTooltip="Interrompi analisi AI"
                    class="action-button"
                  >
                    <mat-icon>stop</mat-icon>
                  </button>
                }
                <!--- Not Ready To Start -->
                @case ("NOT_READY_TO_START") {
                  <mat-icon
                    [matTooltip]="'Non è possibile fare partire l\'analisi in quanto non hai ancora caricato alcun file audio.'"
                  >
                    error_outline
                  </mat-icon>
                }
                <!--- Executed Up To Date -->
                @case ("EXECUTED_UP_TO_DATE") {
                  <mat-icon
                    class="green-check"
                    [matTooltip]="'L\'analisi AI è aggiornata. Carica nuovi file audio per poter eseguire nuovamente l\'analisi.'"
                  >
                    check_circle
                  </mat-icon>
                }
              }
            </td>
          </ng-container>
          <!-- Patient AI Services Columns-->
          <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef>Stato</th>
            <td mat-cell *matCellDef="let patient">
              <div class="ai-analysis-icons">
                <mat-icon
                  [ngClass]="getIconClass(patDmrState)"
                  matTooltip="Scheda Clinica Dinamica"
                  (click)="navigateToAiFeaturesPage('scheda-clinica-dinamica')"
                  >schema</mat-icon
                >
                <mat-icon
                  [ngClass]="getIconClass(patSummState)"
                  matTooltip="Sintesi Complessiva"
                  (click)="navigateToAiFeaturesPage('sintesi-complessiva')"
                  >subject</mat-icon
                >
                <mat-icon
                  class="{{
                    numberOfCompletedAnalyses > 0
                      ? 'icon-green-pointer'
                      : 'icon-grey'
                  }}"
                  matTooltip="Topic Nucleari nel Tempo"
                  (click)="navigateToAiFeaturesPage('grafico-topic')"
                  >trending_up</mat-icon
                >
              </div>
            </td>
          </ng-container>
          <tr
            mat-header-row
            *matHeaderRowDef="[
              'totalAppointments',
              'totalAnalyses',
              'actions',
              'state',
            ]"
          ></tr>
          <tr
            mat-row
            *matRowDef="
              let row;
              columns: [
                'totalAppointments',
                'totalAnalyses',
                'actions',
                'state',
              ]
            "
          ></tr>
        </table>
      </div>
      <div class="action-container">
        <app-clinease-button
          [text]="'Vai a Risultati'"
          (clicked)="navigateToAiFeaturesPage()"
        >
        </app-clinease-button>
      </div>
    </div>
  }
</div>

@if (showInfoPanel) {
  <app-info-panel
    [infoTitle]="infoTitle"
    [infoText]="infoText"
    (close)="toggleInfoPanel()"
  ></app-info-panel>
}
